import React from "react";
import { Page } from "../components/general/Page";
import { PageHeader } from "../components/general/PageHeader";
import { AboutList } from "../components/about/AboutList";
import { useLanguage } from "../contexts";

const About = () => {
  const { t } = useLanguage();
  return (
    <Page>
      <PageHeader
        eyebrow={t("HOME.HEADER.TITLE")}
        title={t("HOME.OUR_STORY")}
        subtitle={t("HOME.HEADER.SUBTITLE")}
      />
      <AboutList />
    </Page>
  );
};

export default About;
